import { getFunctions, httpsCallable } from "firebase/functions";

const SubscriptionPage = () => {
  const openPortal = async () => {
    const functions = getFunctions();
    const createPortal = httpsCallable(functions, "createCustomerPortal");

    const res = await createPortal();
    window.location.href = res.data.url;
  };

  return <button onClick={openPortal}>Manage Subscription</button>;
};

export default SubscriptionPage;
